import React from 'react'

import ModalV4 from '../../../app/ui/modal/v4/v4'
import ItemViewTop from "../../../layout/top/item-view-top/item-view-top"
import FormModel from "../../gd-form/common/form-model-manager"
import CustomEntity from "../../model2/custom-entity/custom-entity"
import ErrorBoundary from "../../error-boundary"
import FormFlex from "../../gd-form/form/form-flex/form"
import FormRowFlex from "../../gd-form/form/form-flex/row"
import FieldFormElement from "../../fields3/render/form-elemnent"
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5-new"
import VScroll from "../../gd-components/scrolling/custom-v-scroll/v-scroll"
import ApiCustomEntity from "../../model2/custom-entity/api"

type Props = {
    params: {
        entity      : CustomEntity
        onSubmit    : func
    }
}

const debug = false
// const debug = "ModalCustomEntity"

export default class ModalCustomEntity extends ModalV4 {

    private form            : FormModel
    private formParams      : FormModel

    constructor(props: Props) {
        super(props)

        const entity : CustomEntity = this.props.params.entity || new CustomEntity({})

        this.form = new FormModel(entity, {
            isFormChanged   : true,
        })

        this.formParams = new FormModel(entity.params, {
            isFormChanged   : true,
        })

        this.state = {
            buttonType: 'primary'
        }
    }

    onSubmitButtonClick = () => {
        this.form.onSubmitClick()
        this.formParams.onSubmitClick()

        if (this.form.isFormValid && this.formParams.isFormValid) {
            this.setState({
                buttonType: 'busy'
            }, ()=>{
                this.onSubmit(this.form.model as CustomEntity)
            })
        }
    }

    onSubmit = async (model: CustomEntity) => {
        // if new model -> create instead of save
        if (model.isNewModel) {
            const response = await ApiCustomEntity.create(model).promise()
            model = new CustomEntity(response)
        } else {
            await model.save()
        }

        this.props.params.onSubmit(model)
    }

    render() {
        const entity : CustomEntity = this.form.model as CustomEntity
        const modalTitle = entity.isNewModel ? "New external entity" : "Edit external entity"

        debug && console.log(debug, 'render', entity)

        return (
            <div className="v4-container placement-middle ui5-iv" style={{width: 840, height: 600}} onClick={this.stopPropagation}>

                <ItemViewTop title="Custom entity" onCloseClick={this.closeModal}/>

                <div className="iv-left-column iv-column">
                    <div className="details-big-icon">
                        <div className="isvg isvg-data-storage"/>
                    </div>
                </div>

                <ErrorBoundary>
                    <div className="iv-cf-form">
                        <div className="iv-header header-left">
                            <div className="title-line">
                                <div className="view-name">
                                    <div className="ui5-title-app-name max-w-350">
                                        {modalTitle}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="iv-content with-left-panel flex-column-left-top">
                            <VScroll>
                                <FormFlex className="flex-column-left-top w-100-percent p-l-30 border-box">
                                    <FormRowFlex field={gd.fields.externalEntity.name} form={this.form}>
                                        <FieldFormElement className = "w-300"
                                                          field     = {gd.fields.externalEntity.name}
                                                          form      = {this.form}
                                                          model     = {entity}/>
                                    </FormRowFlex>

                                    <FormRowFlex field={gd.fields.externalEntity.nameFieldLabel} form={this.formParams}>
                                        <FieldFormElement className = "w-300"
                                                          field     = {gd.fields.externalEntity.nameFieldLabel}
                                                          form      = {this.formParams}
                                                          model     = {entity.params}/>
                                    </FormRowFlex>

                                    <FormRowFlex field={gd.fields.externalEntity.apiUpdateUrl} form={this.formParams}>
                                        <FieldFormElement className = "w-300"
                                                          field     = {gd.fields.externalEntity.apiUpdateUrl}
                                                          form      = {this.formParams}
                                                          model     = {entity.params}/>
                                    </FormRowFlex>

                                    <FormRowFlex field={gd.fields.externalEntity.apiDeleteUrl} form={this.formParams}>
                                        <FieldFormElement className = "w-300"
                                                          field     = {gd.fields.externalEntity.apiDeleteUrl}
                                                          form      = {this.formParams}
                                                          model     = {entity.params}/>
                                    </FormRowFlex>

                                    <FormRowFlex errorClass = "max-w-300-no-truncate"
                                                 field      = {gd.fields.externalEntity.fieldsConfigString}
                                                 form       = {this.form}>
                                        <FieldFormElement className = "w-300"
                                                          field     = {gd.fields.externalEntity.fieldsConfigString}
                                                          form      = {this.form}
                                                          rows      = {2}
                                                          model     = {entity}/>
                                    </FormRowFlex>
                                </FormFlex>
                            </VScroll>
                            <div className="bottom-action flex-row-center-center flex-no-shrink w-100-percent">
                                <ButtonSubmit size      = "36"
                                              label     = "Submit"
                                              type      = {this.state.buttonType}
                                              onClick   = {this.onSubmitButtonClick}/>
                            </div>
                        </div>
                    </div>
                </ErrorBoundary>
            </div>
        )
    }
}
